import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Section, Group, Row, Column, Container } from 'components/core/Page';
import { H2, H3, Paragraph } from 'components/core/Typography';

import movingDesktop from 'assets/images/landing/state-pages/moving-desktop.svg';

import './StatePageReasonsToMove.scss';

export default function StatePageReasonsToMove({
	state,
	reasonsToMove,
	movingTo,
}) {
	return (
		<Container className="state-page-reasons-to-move">
			<Section>
				<Section className="illustration-section">
					<Image src={movingDesktop} />
				</Section>
				<Section>
					<H2
						size="medium"
						color="black"
						className="state-page-title"
					>
						Reasons to Move to {state}
					</H2>
				</Section>
				<Row className="reasons-to-move-row">
					<Column large={11}>
						<Section>
							<div
								className="state-page-subtitle"
								// eslint-disable-next-line react/no-danger
								dangerouslySetInnerHTML={{
									__html: reasonsToMove.copy,
								}}
							/>
						</Section>
					</Column>
				</Row>
				<Section>
					{reasonsToMove.reasons.map((reason, index) => (
						<Group key={reason}>
							<Row className="reasons-to-move-row">
								<Column
									className="number-column"
									large={1}
								>
									<H3
										color="red"
										weight="bold"
										size="mega"
									>
										{index + 1}
									</H3>
								</Column>
								<Column
									className="reason-column"
									large={10}
								>
									<Paragraph weight="light">
										{reason}
									</Paragraph>
								</Column>
							</Row>
						</Group>
					))}
				</Section>
			</Section>
			<Section className="moving-to-section">
				<Section id="moving">
					<H2
						size="medium"
						className="state-page-title"
					>
						Moving to {state}
					</H2>
				</Section>
				<Row className="reasons-to-move-row">
					<Column large={11}>
						<div
							className="moving-to-copy"
							// eslint-disable-next-line react/no-danger
							dangerouslySetInnerHTML={{ __html: movingTo.copy }}
						/>
					</Column>
				</Row>
			</Section>
		</Container>
	);
}

StatePageReasonsToMove.propTypes = {
	state: PropTypes.string.isRequired,
	reasonsToMove: PropTypes.shape({
		copy: PropTypes.string,
		reasons: PropTypes.arrayOf(PropTypes.string),
	}).isRequired,
	movingTo: PropTypes.shape({
		copy: PropTypes.string,
	}).isRequired,
};
